import defaultStateValue from "./default-state-value";


export default function defaultState(mapData, productDefault) {
    let temp = {}

    for (const [key, value] of Object.entries(productDefault)) {
        temp[key] = defaultStateValue(mapData, key, value)
    }
    return temp
}